import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  ButtonVariant,
  Icon,
  IconNames
} from "@wattpad/web-ui-library";
import { Checkbox } from "../shared-components/Checkbox";

export default function CanvaOnboardingModal({
  onCreateWithCanva = () => {},
  onDontShowAgainChange = () => {}
}) {
  const { trans } = wattpad.utils;

  return (
    <div className="canva-onboarding-modal-content">
      <h2 className="canva-onboarding-modal-header">
        {trans("Create with Canva")}
      </h2>

      <div className="canva-onboarding-modal-body">
        <div className="canva-onboarding-modal-illustration" aria-hidden>
          <div className="canva-onboarding-modal-illustration-band">
            <div className="canva-onboarding-modal-pill">
              <Icon name={IconNames.WpShare} size={24} ariaHidden />
              <span>{trans("Share")}</span>
            </div>
            <div className="canva-onboarding-modal-pill-solid">
              <Icon name={IconNames.WpShareIos} size={24} ariaHidden />
              <span>{trans("Return to Wattpad")}</span>
            </div>
          </div>
        </div>

        <div className="canva-onboarding-modal-main">
          <h3 className="canva-onboarding-modal-title">
            {trans("Create with Canva")}
          </h3>

          <p
            className="canva-onboarding-modal-description"
            dangerouslySetInnerHTML={{
              __html: trans(
                "This will open a new design in your Canva account. When you're done, click <b>Return to Wattpad</b> to save it."
              )
            }}
          />

          <div className="canva-onboarding-modal-actions">
            <Button
              variant={ButtonVariant.PRIMARY}
              label={trans("Create with Canva")}
              onClick={onCreateWithCanva}
            />
            <label className="canva-onboarding-modal-dont-show">
              <Checkbox
                defaultValue={false}
                id="canva-onboarding-dont-show-again"
                onChange={onDontShowAgainChange}
              />
              {trans("Don't show this again")}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

CanvaOnboardingModal.propTypes = {
  onCreateWithCanva: PropTypes.func,
  onDontShowAgainChange: PropTypes.func
};
